import React from 'react';
import { useStudentView } from '../../contexts/StudentViewContext';

export function StudentPicker({ onClose }) {
  const { myStudents, setViewingStudent } = useStudentView();
  if (myStudents.length === 0) return null;
  return (
    <div className="category-card" style={{ padding: 8, marginBottom: 12 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--accent)', padding: '4px 8px', marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>View Student</span>
        <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 16 }}>✕</button>
      </div>
      {myStudents.map(s => (
        <button key={s.user_id} onClick={() => { setViewingStudent(s); onClose(); }}
          style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '8px 10px',
            background: 'var(--bg-body)', border: '1px solid var(--border)', borderRadius: 8, cursor: 'pointer', marginBottom: 4, textAlign: 'left' }}>
          <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'linear-gradient(135deg, #10b981, #059669)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 700, flexShrink: 0 }}>
            {(s.display_name || s.username || '?').charAt(0).toUpperCase()}
          </div>
          <span style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' }}>{s.display_name || s.username}</span>
          {s.home_airport && <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>📍 {s.home_airport}</span>}
        </button>
      ))}
    </div>
  );
}
